class MediaQuotes extends HTMLElement {
    constructor() {
        super()

        this.onTriggerEnter = this.onTriggerEnter.bind(this)
        this.onTriggerClick = this.onTriggerClick.bind(this)
        this.onTriggersGroupEnter = this.onTriggersGroupEnter.bind(this)
        this.onTriggersGroupLeave = this.onTriggersGroupLeave.bind(this)

        this.triggersGroup = this.querySelector("[data-quote-triggers]")
        this.triggers = Array.from(
            this.querySelectorAll("[data-quote-trigger]")
        )
        this.panels = Array.from(this.querySelectorAll("[data-quote-panel]"))

        this.autoplayTimer = null
        this.activeIndex = 0
        this.hovering = false
    }

    connectedCallback() {
        this.autoplay = this.hasAttribute("data-autoplay")
        this.autoplayInterval =
            parseInt(this.getAttribute("data-autoplay-interval"), 10) || 6000

        if (this.triggersGroup) {
            this.triggersGroup.addEventListener(
                "mouseenter",
                this.onTriggersGroupEnter
            )
            this.triggersGroup.addEventListener(
                "mouseleave",
                this.onTriggersGroupLeave
            )
        }

        this.triggers.forEach((trigger) => {
            trigger.addEventListener("mouseenter", this.onTriggerEnter)
            trigger.addEventListener("click", this.onTriggerClick)
        })

        // The first quote's text-appear is left to text-appear-animation's own scroll
        // observer (it's the only one not marked data-appear="manual" in the liquid),
        // so skip re-triggering it here on the initial activation.
        this.activate(0, true)
    }

    disconnectedCallback() {
        if (this.triggersGroup) {
            this.triggersGroup.removeEventListener(
                "mouseenter",
                this.onTriggersGroupEnter
            )
            this.triggersGroup.removeEventListener(
                "mouseleave",
                this.onTriggersGroupLeave
            )
        }

        this.triggers.forEach((trigger) => {
            trigger.removeEventListener("mouseenter", this.onTriggerEnter)
            trigger.removeEventListener("click", this.onTriggerClick)
        })

        this.stopAutoplay()
    }

    onTriggersGroupEnter() {
        this.hovering = true
        this.stopAutoplay()
    }

    onTriggersGroupLeave() {
        this.hovering = false
        this.startAutoplay()
    }

    onTriggerEnter(event) {
        this.activate(this.triggers.indexOf(event.currentTarget))
    }

    onTriggerClick(event) {
        event.preventDefault()
        this.activate(this.triggers.indexOf(event.currentTarget))
    }

    activate(index, isInitial = false) {
        if (index < 0 || index >= this.triggers.length) return

        this.activeIndex = index

        this.triggers.forEach((trigger, i) => {
            trigger.classList.toggle("active", i === index)
        })

        this.panels.forEach((panel, i) => {
            panel.classList.toggle("active", i === index)

            const text = panel.querySelector(".text-appear-animation")
            if (!text || !window.TextAppear) return

            // Keep is-active off every panel but the current one — they all share the
            // same bounding box, so text-appear-animation's scroll observer would
            // otherwise reveal all of them together the moment the section comes into
            // view, leaving nothing left to animate the first time a panel is switched to.
            if (i === index) {
                if (!isInitial) window.TextAppear.activate(text)
            } else {
                window.TextAppear.reset(text)
            }
        })

        if (!this.hovering) {
            this.startAutoplay()
        }
    }

    startAutoplay() {
        if (!this.autoplay || this.triggers.length < 2 || this.hovering) return

        this.stopAutoplay()

        this.autoplayTimer = setTimeout(() => {
            this.activate((this.activeIndex + 1) % this.triggers.length)
        }, this.autoplayInterval)
    }

    stopAutoplay() {
        if (this.autoplayTimer) {
            clearTimeout(this.autoplayTimer)
            this.autoplayTimer = null
        }
    }
}

customElements.define("media-quotes", MediaQuotes)
